(function () {
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    var priceEl = document.querySelector('[data-price]');
    var button = form && form.querySelector('[data-add-button]');
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (button) {
        var available = opt.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    });
  });
})();

/* Product cards: click through images with the small arrows */
(function () {
  document.querySelectorAll('[data-card]').forEach(function (card) {
    var imgs = card.querySelectorAll('.card__img');
    var prev = card.querySelector('[data-card-prev]');
    var next = card.querySelector('[data-card-next]');
    if (imgs.length < 2 || !prev || !next) return;
    var index = 0;
    function show(i) {
      index = (i + imgs.length) % imgs.length;
      imgs.forEach(function (img, n) {
        if (n === index) { img.classList.add('is-active'); img.loading = 'eager'; } else { img.classList.remove('is-active'); }
      });
      card.classList.add('is-browsing');
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); show(index - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); show(index + 1); });
    card.addEventListener('mouseleave', function () { if (index === 0) card.classList.remove('is-browsing'); });
  });
})();
